import style from "./NotFoundPage.module.css";
import useTabMenu from "e3-common/hooks/useTabMenu";
import { useBoundStore } from "e3-common/store/useBoundStore";

const NotFoundPage = () => {
  const { selectedMenu } = useBoundStore((state) => state.menu);
  const { closeTab } = useTabMenu();

  const handleClose = () => {
    const { menuId = "" } = selectedMenu || {};
    setTimeout(() => closeTab(menuId), 0);
  };

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.errorCode}>404</div>
        <h1 className={style.title}>페이지를 찾을 수 없습니다</h1>
        <p className={style.message}>요청하신 페이지가 존재하지 않습니다.</p>
        <a className={`${style.homeBtn}`} onClick={handleClose}>
          닫기
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
